import { useFormContext } from 'react-hook-form';
import { formatNumber } from '@/lib/formatUtils';
import { FormFieldV2 } from '../form-field-v2';

type DvtFormFieldV2Props = {
  name?: string;
  ma_vt_data: any;
  disabled?: boolean;
};

export const DvtFormFieldV2 = ({ name = 'dvt', ma_vt_data, disabled = false }: DvtFormFieldV2Props) => {
  const { watch } = useFormContext();
  const dvtValue = watch(name);

  if (!ma_vt_data || !ma_vt_data?.dvt_data) return null;

  const dvtOpts = [
    {
      value: ma_vt_data?.dvt,
      label: ma_vt_data?.dvt_data?.ten_dvt
    }
  ];
  const quyDoiOpts =
    ma_vt_data?.quy_doi_dvt_data?.map((item: any) => ({
      value: item.dvt,
      label: item.dvt_data?.ten_dvt
    })) || [];
  const options = [...dvtOpts, ...quyDoiOpts].filter(
    (option, index, array) => array.findIndex(item => String(item.value) === String(option.value)) === index
  );

  const selectedDvt = dvtValue || ma_vt_data?.dvt;
  const selectedQuyDoi = ma_vt_data?.quy_doi_dvt_data?.find((item: any) => item.dvt === selectedDvt);
  const heSo = selectedQuyDoi?.he_so;

  return (
    <div className='flex w-full items-center gap-x-2'>
      <div className='min-w-0 flex-1'>
        <FormFieldV2 name={name} type='select' options={options} disabled={disabled} className='w-full' />
      </div>

      {Number(heSo) > 0 && (
        <p className='shrink-0 whitespace-nowrap text-right text-[10px] font-semibold text-green-600'>
          {`=${formatNumber(heSo)}(${ma_vt_data?.dvt_data?.ten_dvt})`}
        </p>
      )}
    </div>
  );
};
